import React, { useState, useContext } from "react";
import { useParams } from "react-router-dom";
import Textarea from "react-autosize-textarea";

import { VoterNameContext } from "../../voter-duckling.js";

import { submitWriteup } from "../../api.js";
import { games } from "../../data/matchups";

import styles from "./writeup.module.css";

let teamNameFromLabel = (label) => `team${label.slice(-1)}`;

let Writeup = ({ writeup, label, gameOver }) => {
  let { gameNumber } = useParams();
  let game = games[gameNumber];
  let team = game[teamNameFromLabel(label)];
  let { voter } = useContext(VoterNameContext);
  let [newWriteup, setNewWriteup] = useState(writeup);
  let [isDirty, setIsDirty] = useState(false);
  let [hasStartedEditing, setHasStartedEditing] = useState(false);
  // debugger;
  if (writeup && !hasStartedEditing && writeup !== newWriteup) {
    setNewWriteup(writeup);
  }
  let lines = newWriteup.split("\n");

  let writeupInput = (
    <>
      <h4>Add or edit your writeup:</h4>
      <Textarea
        className={styles.input}
        value={newWriteup}
        onChange={(e) => {
          setNewWriteup(e.target.value);
          setIsDirty(true);
          setHasStartedEditing(true);
        }}
      />
      {isDirty ? (
        <button
          className={styles.button}
          disabled={!isDirty}
          onClick={() => {
            submitWriteup(gameNumber, label, newWriteup).then((_) => {
              setIsDirty(false);
              window.location.reload();
            });
          }}
        >
          submit writeup
        </button>
      ) : null}
      <div className={styles.spacer} />
    </>
  );

  return !gameOver &&
    team &&
    team.owner.toLowerCase() === voter.toLowerCase() ? (
    writeupInput
  ) : writeup ? (
    <div className={styles.writeup}>
      {lines.map((line, index) => (
        <p key={index}>{line}</p>
      ))}
    </div>
  ) : null;
};

export default Writeup;
